// src/components/ProtectedRoute.js
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from './Loading';

const AUTH_ONLY_PATHS = ['/login', '/signup', '/forgot-password', '/reset-password'];

/**
 * Gate for the whole app: logged-out users are sent to /login (their
 * intended destination is preserved in router state so Login can
 * bounce them back). Logged-in users are kept out of the auth-only
 * screens and sent to their intended destination, or home.
 */
export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading message="Loading..." size="large" overlay={true} />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export const AuthOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading message="Loading..." size="large" overlay={true} />;
  }

  if (user) {
    const destination = location.state?.from?.pathname || '/';
    return <Navigate to={destination} replace />;
  }

  return children;
};

AuthOnlyRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AUTH_ONLY_PATHS };
